import { EventEmitter, Injectable, Output } from '@angular/core'
import { Observable, of } from 'rxjs'
import { data } from './menu.service.mock'

@Injectable({
  providedIn: 'root',
})
export class MenuService {

  loading = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.loading = !this.loading;
    this.change.emit(this.loading);
  }

  // TODO: change to api
  getLeftMenu(): Observable<any[]> {
    return of(data)
  }

  getTopMenu(): Observable<any[]> {
    return of(data)
  }
}
